import React from 'react'
import './MobileContent.scss'

function MobileContent() {
  return (
    <div className='mobileContent'>
      <p>
        My name is William Simms. I have two accounts I use on a semi regular basis. Those are my{' '}
        <a href='https://twitter.com/wijlum' target='_blank' rel='noopener noreferrer'>
          Twitter
        </a>{' '}
        account and my{' '}
        <a href='https://github.com/williamsimms' target='_blank' rel='noopener noreferrer'>
          Github
        </a>{' '}
        account. Feel free to follow me on any of those. I also just got finished with a small project. That can be
        found{' '}
        <a href='https://facebook-63b89.web.app/' target='_blank' rel='noopener noreferrer'>
          here
        </a>
        . If you have any inquires about the project or me in general you can also email me{' '}
        <a href='mailto:williamsimms193@gmail.com' target='_blank' rel='noopener noreferrer'>
          here
        </a>
        .
      </p>
    </div>
  )
}

export default MobileContent
